import React from 'react';

const LocalImage = ({alt, src}) => {
    return (
        <div className="ui image">
            <img
                alt={alt}
                class="ui fluid image"
                src={src}>
            </img>
        </div>
    );
}

export default LocalImage;